module.exports = __webpack_public_path__ + "img/check-circle-1.299bc18f.svg";